exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".Logout_Logout_3XHnt {\n    margin-top: 60px;\n}", ""]);

// Exports
exports.locals = {
	"Logout": "Logout_Logout_3XHnt"
};